import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';

const DeleteModal = ({
  heading,
  buttonTitle,
  isDeleting = false,
  show,
  onDeleteClick,
  onCloseClick,
  componentName,
  Label = 'Delete'
}) => {
  return (
    <Modal size="l" isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalHeader>
        {Label} {componentName ? componentName : ''}
      </ModalHeader>
      <button
        type="button"
        onClick={onCloseClick}
        className="btn-close position-absolute end-0 top-0 m-3"
      ></button>
      <div className="modal-content">
        <ModalBody className="">
          {/* <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-trash-can-outline"></i>
            </div>
          </div> */}
          <p className="font-size-16 mb-4">
            {/* Are you sure you want to permanently erase the {name || 'job'}. */}
            {heading ? heading : 'Are you sure you want to permanently erase ?'}
          </p>
        </ModalBody>
      </div>
      <ModalFooter>
        <div className="hstack gap-2 justify-content-center mb-0">
          <button
            disabled={isDeleting}
            type="button"
            className="btn btn-primary"
            onClick={onDeleteClick}
          >
            {isDeleting
              ? buttonTitle
                ? `Loading...`
                : 'Deleting'
              : buttonTitle
                ? buttonTitle
                : 'Delete Now'}
          </button>
          {/* <button disabled={isDeleting} type="button" className="btn btn-light" onClick={onCloseClick}>
            Cancel
          </button> */}
          <Button disabled={isDeleting} color="secondary" onClick={onCloseClick}>
            Cancel
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  isDeleting: PropTypes.bool,
  name: PropTypes.any,
  buttonTitle: PropTypes.any,
  heading: PropTypes.any,
  componentName: PropTypes.any,
  Label: PropTypes.any
};

export default DeleteModal;
